import { useSelector } from 'react-redux';
import { modalParamsSelector } from 'redux/modules/modal';
import { COUPON_DETAILS, PRO_TRIAL_DETAILS } from './constants';
import { PromoModalDetailsWithTemplate } from './types';

export default function usePromotionDetails(): PromoModalDetailsWithTemplate {
  const { promotionType } = useSelector(modalParamsSelector) || {};

  return promotionType === 'proTrial' ? PRO_TRIAL_DETAILS : COUPON_DETAILS;
}
